import * as React from 'react';
import { Link as RouterLink, LinkProps as RouterLinkProps } from 'react-router-dom';
import MuiLink, { LinkProps } from '@mui/material/Link';

export const Link = React.forwardRef<any, RouterLinkProps & LinkProps>((props, ref) => (
	<MuiLink ref={ref} underline="none" component={RouterLink} {...(props as any)} />
));
